import Cookies from 'js-cookie'
import { useEffect, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import * as yup from 'yup'

import { useAppDispatch } from './index'

const paramsSchema = yup.object().shape({
  nameProduct: yup.string().required(),
  platform: yup.string().required(),
  idUser: yup.string().required()
})

export const useSaveParamsPartner = () => {
  const dispatch = useAppDispatch()
  const [params, setSearchParams] = useSearchParams()

  const paramsObject = useMemo(
    () => ({
      nameProduct: params.get('nameProduct'),
      platform: params.get('platform'),
      idUser: params.get('idUser')
    }),
    [params]
  )

  useEffect(() => {
    paramsSchema
      .validate(paramsObject)
      .then(() => {
        // Параметры валидны, не пропускаем запрос
        setSearchParams(prev => {
          prev.delete('nameProduct')
          prev.delete('platform')
          prev.delete('idUser')
          return prev
        })
      })
      .catch(() => {
        console.warn('catch')
      })
    const nameProduct = params.get('nameProduct')
    const platform = params.get('platform')
    const idUser = params.get('idUser')

    if (nameProduct && platform && platform.length && idUser && idUser.length) {
      sessionStorage.setItem(
        'dataFromUser',
        JSON.stringify({ code: nameProduct, lead_platform: platform, external_id: idUser })
      )
    }
  }, [dispatch, params, paramsObject, setSearchParams])
}
